// extracted by mini-css-extract-plugin
export default {"cartitems":"Cart_cartitems__2NECl","total":"Cart_total__zlhrO","actions":"Cart_actions__16OXW","button--alt":"Cart_button--alt__W1uyJ","button":"Cart_button__3Z03x"};